import { Component } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  DefaultControlErrorComponent,
  errorTailorImports,
} from '@ngneat/error-tailor';

@Component({
  standalone: true,
  imports: [errorTailorImports, MatFormFieldModule],
  template: `
    @if (!hideError) {
      <span [innerHTML]="errorText"></span>
    }
  `,
})
export class FormControlErrorComponent extends DefaultControlErrorComponent {}
